import { combineLatest, Observable } from 'rxjs';
import { filter, map, shareReplay, startWith, take } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';

import { Store } from '@ngxs/store';

import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';

import { CustomerState } from '@app/core/store/states/customer/customer.state';
import { AlertsCenterDrawerComponent } from '../components/drawer/alerts-center-drawer.component';

@Injectable({
  providedIn: 'root',
})
export class AlertsCenterService {
  readonly isOnAlertsPage$: Observable<boolean> = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    startWith(0),
    map(() => this.router.url.startsWith('/notifications')),
    shareReplay(1),
  );

  private drawerRef?: NzDrawerRef;

  get isOpen(): boolean {
    return !!this.drawerRef;
  }

  constructor(
    private ds: NzDrawerService,
    private router: Router,
    private store: Store,
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => this.closeDrawer());
  }

  toggleDrawer(): void {
    combineLatest([this.isOnAlertsPage$, this.store.select(CustomerState.hasNotificationsAccess)])
      .pipe(take(1))
      .subscribe(([disableOpen, enabled]) => {
        if (!disableOpen && enabled) {
          this.isOpen ? this.closeDrawer() : this.openDrawer();
        }
      });
  }

  private openDrawer(): void {
    const drawerRef = this.ds.create({
      nzWidth: 512,
      nzClosable: false,
      nzPlacement: 'right',
      nzContent: AlertsCenterDrawerComponent,
    });

    drawerRef.afterClose.subscribe(() => {
      if (this.drawerRef === drawerRef) {
        this.drawerRef = void 0;
      }
    });

    this.drawerRef = drawerRef;
  }

  private closeDrawer(): void {
    if (this.drawerRef) {
      this.drawerRef.close();
      this.drawerRef = void 0;
    }
  }
}
